import React from 'react';

import * as THREE from 'three';

import { BeveledPanel } from '../Equipment/FabProcessTool/BeveledPanel';

import { getStockerMaterials } from './StockerMaterials';

import type { StockerDimensions } from './stockerTypes';



export type StockerInteriorProps = {

  dims: StockerDimensions;

  opacity?: number;

};



/** Interior ceiling wash + rack backlight (floor deck is StockerLoadPortBank on +Z). */

export const StockerInterior: React.FC<StockerInteriorProps> = ({ dims, opacity = 1 }) => {

  const mats = getStockerMaterials(opacity);

  const { width, depth, glassW, glassH, glassY, pillarTop } = dims;



  const floorW = glassW * 0.72;



  return (

    <group name="StockerInterior">

      {/* Top interior ceiling wash */}

      <mesh position={[0, pillarTop - glassH * 0.04, depth * 0.05]} rotation={[Math.PI / 2, 0, 0]}>

        <planeGeometry args={[floorW * 0.95, depth * 0.48]} />

        <meshStandardMaterial

          color="#F8FAFC"

          emissive="#E2E8F0"

          emissiveIntensity={0.05 * opacity}

          transparent

          opacity={0.12 * opacity}

          toneMapped={false}

          depthWrite={false}

          side={THREE.DoubleSide}

        />

      </mesh>



      {/* Side rack backlight strips */}

      {([-1, 1] as const).map((side) => (

        <BeveledPanel

          key={`rack-backlight-${side}`}

          size={[width * 0.012, glassH * 0.82, depth * 0.014]}

          material={mats.cyanLed}

          position={[side * width * 0.32, glassY, -depth * 0.08]}

        />

      ))}

    </group>

  );

};



export default StockerInterior;

